module.exports = __webpack_public_path__ + "img/icon-letter-r.704b81ff.svg";